import {
  FETCH_ANALYTICS_OVERVIEW,
  FETCH_ANALYTICS_OVERVIEW_SUCCESS,
  FETCH_ANALYTICS_OVERVIEW_FAILURE,
  FETCH_ANALYTICS_ENGAGEMENT,
  FETCH_ANALYTICS_ENGAGEMENT_SUCCESS,
  FETCH_ANALYTICS_ENGAGEMENT_FAILURE,
  FETCH_ANALYTICS_GENRES,
  FETCH_ANALYTICS_GENRES_SUCCESS,
  FETCH_ANALYTICS_GENRES_FAILURE,
  FETCH_ANALYTICS_LEADERBOARDS,
  FETCH_ANALYTICS_LEADERBOARDS_SUCCESS,
  FETCH_ANALYTICS_LEADERBOARDS_FAILURE,
  FETCH_ANALYTICS_BOOKS,
  FETCH_ANALYTICS_BOOKS_SUCCESS,
  FETCH_ANALYTICS_BOOKS_FAILURE,
  FETCH_ANALYTICS_USERS,
  FETCH_ANALYTICS_USERS_SUCCESS,
  FETCH_ANALYTICS_USERS_FAILURE,
  FETCH_ANALYTICS_SESSIONS,
  FETCH_ANALYTICS_SESSIONS_SUCCESS,
  FETCH_ANALYTICS_SESSIONS_FAILURE,
  EXPORT_ANALYTICS_CSV,
  EXPORT_ANALYTICS_CSV_SUCCESS,
  EXPORT_ANALYTICS_CSV_FAILURE,
} from "../ActionTypes";

const dataset = (data) => ({ data, loading: false, error: null, loaded: false });
const paginated = () => dataset({ page: 1, limit: 20, total: 0, data: [] });

const INIT_STATE = {
  overview: dataset(null),
  engagement: dataset({ series: [], totals: {} }),
  genres: dataset({ total_books_read: 0, genres: [] }),
  leaderboards: dataset({ limit: 5, categories: [] }),
  books: paginated(),
  users: paginated(),
  sessions: paginated(),
  export: dataset(null),
};

const actionMap = {
  [FETCH_ANALYTICS_OVERVIEW]: ["overview", "request"],
  [FETCH_ANALYTICS_OVERVIEW_SUCCESS]: ["overview", "success"],
  [FETCH_ANALYTICS_OVERVIEW_FAILURE]: ["overview", "failure"],
  [FETCH_ANALYTICS_ENGAGEMENT]: ["engagement", "request"],
  [FETCH_ANALYTICS_ENGAGEMENT_SUCCESS]: ["engagement", "success"],
  [FETCH_ANALYTICS_ENGAGEMENT_FAILURE]: ["engagement", "failure"],
  [FETCH_ANALYTICS_GENRES]: ["genres", "request"],
  [FETCH_ANALYTICS_GENRES_SUCCESS]: ["genres", "success"],
  [FETCH_ANALYTICS_GENRES_FAILURE]: ["genres", "failure"],
  [FETCH_ANALYTICS_LEADERBOARDS]: ["leaderboards", "request"],
  [FETCH_ANALYTICS_LEADERBOARDS_SUCCESS]: ["leaderboards", "success"],
  [FETCH_ANALYTICS_LEADERBOARDS_FAILURE]: ["leaderboards", "failure"],
  [FETCH_ANALYTICS_BOOKS]: ["books", "request"],
  [FETCH_ANALYTICS_BOOKS_SUCCESS]: ["books", "success"],
  [FETCH_ANALYTICS_BOOKS_FAILURE]: ["books", "failure"],
  [FETCH_ANALYTICS_USERS]: ["users", "request"],
  [FETCH_ANALYTICS_USERS_SUCCESS]: ["users", "success"],
  [FETCH_ANALYTICS_USERS_FAILURE]: ["users", "failure"],
  [FETCH_ANALYTICS_SESSIONS]: ["sessions", "request"],
  [FETCH_ANALYTICS_SESSIONS_SUCCESS]: ["sessions", "success"],
  [FETCH_ANALYTICS_SESSIONS_FAILURE]: ["sessions", "failure"],
  [EXPORT_ANALYTICS_CSV]: ["export", "request"],
  [EXPORT_ANALYTICS_CSV_SUCCESS]: ["export", "success"],
  [EXPORT_ANALYTICS_CSV_FAILURE]: ["export", "failure"],
};

const overviewReducer = (state = INIT_STATE, action) => {
  const config = actionMap[action.type];
  if (!config) return state;

  const [key, lifecycle] = config;
  if (lifecycle === "request") {
    return { ...state, [key]: { ...state[key], loading: true, error: null } };
  }
  if (lifecycle === "success") {
    return {
      ...state,
      [key]: { data: action.payload, loading: false, error: null, loaded: true },
    };
  }
  return { ...state, [key]: { ...state[key], loading: false, error: action.payload } };
};

export default overviewReducer;
